import { __decorate } from "tslib";
import { FITDATAIDS } from "../fitData/consts";
import { BaseState } from "../state/BaseState";
import { StateDefine } from "../state/utils/StateDefine";
import { getFormDataSchema } from "../stateCommon/form";
import { StateProxy } from "./utils/defineProxyState";
export class FormStateJS extends BaseState {
  constructor(collection, options) {
    super(collection, options);
    this.stateModel = 'form_JS';
    this.ucTag = '表单';
    this.fitDataId = FITDATAIDS.formJS;
    this.formData = {};
    this.initState();
  }
}
FormStateJS.stateModel = 'form_JS';
__decorate([StateDefine(getFormDataSchema), StateProxy], FormStateJS.prototype, "formData", void 0);
//# sourceMappingURL=FormStateJS.js.map
